import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'material-inventory-transaction-error',
    templateUrl: './material-inventory-transaction-error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaterialInventoryTransactionErrorComponent {

  @Input() errors: { [key: string]: any; } = {};

  constructor() { }

}
